<template>
    <el-dialog
        :title="editParams.title"
        :visible.sync="modelValue"
        customClass="submit_cofirm_dialog"
        width="360"
        center
        >
            <template>
                <p class="submit_cofirm_dialog_info">{{editParams.content}}</p>
                <div class="submit_cofirm_dialog_reason" v-if="editParams.status == -2 && false">
                    <p><span style="color: #f56c6c;margin-right: 4px">*</span><span>下架原因：</span></p>
                    <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="textarea"
                    maxlength="200"
                    @blur="resonBlur"
                    show-word-limit
                    resize="none"
                    />
                </div>
            </template>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" size="small">{{editParams.cancelBtn}}</el-button>
                <el-button type="primary" @click="sure" size="small">{{editParams.sureBtn}}</el-button>
                <!-- <el-button type="primary" @click="sure" size="small" :disabled="!textarea && editParams.status == -2">{{editParams.sureBtn}}</el-button> -->
            </div>
    </el-dialog>
</template>
<script>
    export default {
        name: 'SubmitDialog',
        props: {
            editParams: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            value: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
				dialogVisible: false,
                textarea: ''
            }
        },
        computed: {
            modelValue: {
                get() {
                    return this.value
                },
                set(news) {
                    this.$emit('input', news)
                }
            }
        },
        methods: {
            sure() {
                this.$emit('sure')
                this.textarea = ''
            },
            cancel() {
                this.modelValue = false
                this.textarea = ''
            }
        }
    }
</script>
